import React from "react";
import type { IconProps } from "./types";

/**
 * A content library icon component that displays a book with a lightbulb,
 * representing knowledge, learning resources, or a content library.
 * @param props - The component props
 * @param props.className - Optional CSS class name to apply to the SVG element
 * @param props.width - The width of the icon in pixels
 * @param props.height - The height of the icon in pixels
 * @param props.strokeWidth - The stroke width for the SVG paths
 * @returns A React functional component that renders a content library SVG icon
 */
const ContentLibraryIcon: React.FC<IconProps> = ({ className, width = 24, height = 24, strokeWidth = 1 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      id="Read-Light-Idea--Streamline-Ultimate"
      height={height}
      width={width}
      className={className}
    >
      <path
        d="M23 10v9.021a1 1 0 0 1 -0.984 1C16.583 20.18 12 21.677 12 23.5c0 -1.824 -4.584 -3.321 -10.016 -3.485a1 1 0 0 1 -0.984 -1V4.518a1 1 0 0 1 1.017 -1C7.435 3.686 12 5.181 12 7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="M3.5 8A20.582 20.582 0 0 1 10 9.421"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="M3.5 11.405a20.585 20.585 0 0 1 6.5 1.419"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="M3.5 14.809a20.557 20.557 0 0 1 6.5 1.419"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="m12 7.001 0 16.375"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="M21 6.5a3 3 0 1 0 -4 2.817V10.5h2V9.318A2.992 2.992 0 0 0 21 6.5Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="m17 12.501 2 0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="m17.5 14.501 1 0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="m18 1.501 0 -1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="m21.536 2.966 0.707 -0.707"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
      <path
        d="m14.465 2.966 -0.708 -0.707"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
};

export default ContentLibraryIcon;
